<ion-header>
  <pos-training-mode-banner></pos-training-mode-banner>
  <ion-toolbar mode="md" [color]="color">
    <ion-buttons slot="start">
      <ion-button *ngIf="hasBackDetailedButton" mode="md" class="navigate-back" (click)="exit()">
        <ion-icon slot="start" name="arrow-back-outline"></ion-icon>
        <span class="ion-text-capitalize"> {{'common.back' | transloco}} </span>
      </ion-button>
      <ion-button *ngIf="hasBackButton" mode="md" (click)="exit()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
      <ng-content select="[start-buttons]"></ng-content>
    </ion-buttons>
    <ion-title class="ion-text-center">{{ title }}<ng-container *ngIf="subtitle"> - {{ subtitle }}</ng-container>
    </ion-title>
    <ion-buttons slot="end">
      <ng-content select="[end-buttons]"></ng-content>
      <pos-language-switcher></pos-language-switcher>

      <ion-button *ngIf="hasCloseButton" mode="md" (click)="exit()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
      <ion-button (click)="openMenu()" mode="md">
        <ion-icon size="large" name="menu-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ng-content select="[extra-content]"></ng-content>
</ion-header>